import {
  chartAPI,
  ChartAPIReturn,
  CreateChartOptions,
  RangeHorizon,
  SeriesType,
  TsDataPoint,
} from '@toggle/chart';
import React, { useEffect, useRef } from 'react';

const barsData = [
  {
    time: '2022-02-23T00:00:00.000Z',
    open: 254.68,
    close: 260,
    high: 264,
    low: 252,
  },
  {
    time: '2022-03-30T00:00:00.000Z',
    open: 364.6628,
    close: 358,
    high: 380,
    low: 352,
  },
  {
    time: '2022-04-14T00:00:00.000Z',
    open: 328.333,
    close: 320,
    high: 334,
    low: 310,
  },
  {
    time: '2018-12-27',
    open: 21.45,
    close: 19.89,
    high: 22,
    low: 19.4,
  },
  {
    time: '2018-12-28',
    open: 25.46,
    close: 27.45,
    high: 29,
    low: 24.3,
  },
  {
    time: '2018-12-30',
    open: 22.68,
    close: 26.68,
    high: 28.4,
    low: 21.3,
  },
];

export interface ChartAreaProps {
  options: CreateChartOptions;
  data: TsDataPoint[];
  selectedRange: RangeHorizon;
  selectedSeriesType: SeriesType;
}

export const ChartArea = ({
  options,
  data,
  selectedRange,
  selectedSeriesType,
}: ChartAreaProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const chartApiRef = useRef<null | ChartAPIReturn>(null);
  const prevSelectedRange = useRef<RangeHorizon>();
  const prevSelectedChartType = useRef<SeriesType>();

  useEffect(() => {
    if (canvasRef.current) {
      chartApiRef.current = chartAPI({
        canvasElement: canvasRef.current,
        options,
      });

      chartApiRef.current?.paint({
        data,
        timeseries: barsData,
        horizon: selectedRange,
      });
    }
    return () => {
      chartApiRef.current?.destroy();
    };
  }, [options.width, options.height, data]);

  useEffect(() => {
    if (chartApiRef.current && prevSelectedRange.current) {
      chartApiRef.current.changeRangeHorizon(selectedRange);
    }
    prevSelectedRange.current = selectedRange;
  }, [selectedRange]);

  useEffect(() => {
    if (chartApiRef.current && prevSelectedChartType.current) {
      chartApiRef.current.changeSeriesType(selectedSeriesType);
    }
    prevSelectedChartType.current = selectedSeriesType;
  }, [selectedSeriesType]);

  return (
    <canvas
      data-testid="chart-area-canvas"
      ref={canvasRef}
      style={{ width: options.width, height: options.height }}
    />
  );
};
